<template>
  <a-modal
    :title="createPro"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="500px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="isLimitDialogShow = false"
  >
    <div class="creat-dilog-form">
      <a-form
        ref="createForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${projectNameTit}：`"
          prop="projectname"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
          class="total-input-box"
        >
          <a-input
            v-decorator="['projectname', {
              rules: [{
                required: true, message: $t('message[814]')
              }],
              initialValue: formData.projectname || ''
            }]"
            type="text"
            :placeholder="projectnamePlace"
            :maxlength="20"
            @change="getValue"
          />
          <span class="input-length-num">{{ valData ? valData.length : 0 }}/20</span>
        </a-form-item>
        <a-form-item
          :label="`${chargeTit}：`"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-decorator="['adminid', {
              rules: [{
                required: true, message: $t('message[861]')
              }],
              initialValue: formData.adminid || ''
            }]"
            show-search
            mode="multiple"
            :filter-option="false"
            :not-found-content="emptyTip"
            :placeholder="chargePersonPlace"
            @search="handleSearch"
            @blur="handleBlur"
          >
            <a-select-option
              v-for="(item, index) in realbackAdminListDatas"
              :key="index"
              :label="`${item.truename}`"
              :value="item.userid"
            >
              {{ item.truename }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from '@/lib/utils'
import { getStorage } from '@/lib/storage'

export default {
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      valData: '',
      formData: {
        projectname: '',
        adminid: []
      },
      isrelated: 1
    }
  },
  computed: {
    ...mapState('organization/orgRealback', ['realbackAdminListDatas', 'datas']),
    cId () {
      return this.$route.query.cid * 1
    },
    createPro () {
      return this.projectItemData.projectid ? '修改广告回传管理项目' : '创建广告回传管理项目'
    },
    chargeTit () {
      return this.$t('message["330"]')
    },
    projectnamePlace () {
      return this.$t('message["814"]')
    },
    chargePersonPlace () {
      return this.$t('message["861"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    projectNameTit () {
      return this.$t('message["1325"]')
    },
    emptyTip () {
      return this.$t('message["1551"]')
    }
  },
  watch: {
    async isLimitDialogShow (val) {
      if (val) {
        this.getRealbackAdminId({ cid: this.cId })
      }
    }
  },
  created () {
    this.form = this.$form.createForm(this)
    const { projectname, adminid = [] } = this.projectItemData || {}
    this.formData.projectname = projectname
    this.formData.adminid = adminid
    this.handleSearch = debounce(this.handleSearch, 1000)
  },
  methods: {
    ...mapActions('organization/org', ['fetchProjectList']),
    ...mapActions('organization/orgRealback', ['ajaxEditPro', 'getRealbackAdminId']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const realbackCid = getStorage('realbackCid')
          let formDatas = Object.assign(values, {
            cid: realbackCid,
            cid2: this.cId
          })

          if (this.projectItemData.projectid) {
            formDatas.projectid = this.projectItemData.projectid
          }

          const chain = await this.ajaxEditPro({ ...formDatas })
          chain
            .setForm(this.form)
            .onSuccess(async () => {
              const chain2 = await this.fetchProjectList({ cid: this.cId })
              chain2.fetch()
            })

          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    },
    async handleSearch (val) {
      try {
        await this.getRealbackAdminId({
          cid: this.cId,
          keywords: val
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleBlur () {
      this.getRealbackAdminId({ cid: this.cId })
    },
    getValue (e) {
      this.valData = e.target.value
    }
  }
}
</script>

<style lang="scss" scoped>
.input-length-num {
  position: absolute;
  right: 6px;
  top: -8px;
}
.create-tip {
  background: #E8F4FF;
  padding: 8px 24px;
  border-top : 1px solid #4CA0F2;
  border-bottom : 1px solid #4CA0F2;
  line-height: 24px;
  margin: -24px -24px 24px;
}
.related-project-item ::v-deep {
  border-top:  1px dashed #d6d6d6;
  padding-top: 16px;
  .ant-radio-wrapper {
    line-height: 32px;
  }
}
.related-projects-list {
  padding-top: 10px;
  margin-bottom: -10px;
}
</style>
